import { render, staticRenderFns } from "./HomePageComponent.vue?vue&type=template&id=f18c22d4"
import script from "./HomePageComponent.vue?vue&type=script&lang=js"
export * from "./HomePageComponent.vue?vue&type=script&lang=js"
import style0 from "./HomePageComponent.vue?vue&type=style&index=0&id=f18c22d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports